import axios from 'axios';
import {push} from 'react-router-redux';

import customer from '../customer';
const {getSubscriptions} = customer.selectors;

import * as endpoints from '../common/apiEndpoints';
import * as permissions from '../common/userPermissions';

import * as types from './actionTypes';

export function getAllUsers() {
  return function(dispatch) {
    axios.get(endpoints.CUSTOMER_ALLUSERS)
      .then((response) => {
        dispatch(allUsersReceived(response));
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });
  };
}

function allUsersReceived(response) {
  return function(dispatch, getState) {
    let userList = [];
    const users = response.data;
    users.forEach((user) => {
      
      let userSubscriptionList = createPermissionTable(getState());
      const remoteSubscriptionList = user.SubscriptionPermissions;

      userSubscriptionList.forEach((userSubscription) => {
        let currentSubscription = remoteSubscriptionList.find((remoteSubscription) => {
          return remoteSubscription.SubscriptionId === userSubscription.id;
        });
        if(currentSubscription !== undefined) {
          userSubscription.permissions = {
            accessCareSheets: currentSubscription.Permissions.includes(permissions.ACCESS_CARE_SHEETS),
            accessLabels: currentSubscription.Permissions.includes(permissions.ACCESS_LABELS),
            manageArticles: currentSubscription.Permissions.includes(permissions.MANAGE_ARTICLES),
            manageLogo: currentSubscription.Permissions.includes(permissions.MANAGE_LOGO),
            manageCareSheetAds: currentSubscription.Permissions.includes(permissions.MANAGE_CARE_SHEET_ADS)
          };
        }
      });

      let userInfo = {
        userName: user.Username,
        firstName: user.Firstname,
        lastName: user.Lastname,
        isActive: user.IsActive,
        subscriptions: userSubscriptionList
      };
      userList.push(userInfo);
    });

    dispatch({
      type: types.ALL_USERS_RECEIVED,
      payload: {
        users: userList
      }
    });
  };
}

export function initializePermissionTable() {
  return function(dispatch, getState) {
    const subscriptionList = createPermissionTable(getState());
    dispatch({
      type: types.INITIALIZE_PERMISSION_TABLE,
      payload: {
        subscriptions: subscriptionList
      }
    });
  };
}

function createPermissionTable(state) {
  const masterSubscriptionList = getSubscriptions(state);
    let subscriptionList = [];
    masterSubscriptionList.forEach((subscription) => {
    let emptySubscription = {
      id: subscription.id,
      name: subscription.name,
      permissions: {
        accessCareSheets: false,
        accessLabels: false,
        manageArticles: false,
        manageLogo: false,
        manageCareSheetAds: false
      }
    };
    subscriptionList.push(emptySubscription);
  });
  return subscriptionList;
}

export function selectUser(user) {
  return {
    type: types.SELECT_USER,
    payload: {
      selectedUser: user
    }
  };
}

export function deselectUser() {
  return {
    type: types.DESELECT_USER
  };
}

export function registerUser(userInfo, permissionTable) {
  return function(dispatch) {
    dispatch({
      type: types.REGISTER_USER_ATTEMPT
    });

    initializePermissionTable();
    
    const userInfoPost = {
      'Email': userInfo.email,
      'Password': userInfo.password,
      'ConfirmPassword': userInfo.confirmPassword,
      'Firstname': userInfo.firstName,
      'Lastname': userInfo.lastName,
      'IsActive': true
    };
    
    return new Promise((resolve, reject) => {
      axios.post(endpoints.REGISTER_USER, userInfoPost)
        .then(() => {
          const newUserInfo = {
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            status: true
          };
          return dispatch(updateUser(userInfo.email, newUserInfo, permissionTable));
        })
        .catch(() => {
          dispatch({type: types.SHOW_ERROR_MODAL});
          reject();
        });
    });
  };
}

function createPermissionsArray(permissionTable) {
  let subscriptionPermissions = [];
  permissionTable.forEach((subscription) => {
    const {accessCareSheets, accessLabels, manageArticles, manageLogo, manageCareSheetAds} = subscription.permissions;
    let subPermissions = [];
    if(accessCareSheets) { subPermissions.push(permissions.ACCESS_CARE_SHEETS); }
    if(accessLabels) { subPermissions.push(permissions.ACCESS_LABELS); }
    if(manageArticles) { subPermissions.push(permissions.MANAGE_ARTICLES); }
    if(manageLogo) { subPermissions.push(permissions.MANAGE_LOGO); }
    if(manageCareSheetAds) { subPermissions.push(permissions.MANAGE_CARE_SHEET_ADS); }

    let prepSubscription = {
      'SubscriptionName': subscription.name,
      'SubscriptionId': subscription.id,
      'Permissions': subPermissions
    };
    
    subscriptionPermissions.push(prepSubscription);
  });
  return subscriptionPermissions;
}

function createUpdateUserArray(userName, userInfo, permissionTable) {
  let subscriptionPermissions = createPermissionsArray(permissionTable);
  let user = {
    'Username': userName,
    'Firstname': userInfo.firstName,
    'Lastname': userInfo.lastName,
    'IsActive': userInfo.status,
    'SubscriptionPermissions': subscriptionPermissions
  };
  let userArray = [];
  userArray.push(user);
  return userArray;
}

function updateUser(userName, userInfo, permissionTable) {
  return function(dispatch) {
    const userArray = createUpdateUserArray(userName, userInfo, permissionTable);
    return new Promise((resolve, reject) => {
      axios.post(endpoints.UPDATE_USER, userArray)
        .then((response) => {
          dispatch(allUsersReceived(response));
          dispatch(push('/users'));
          resolve();
        })
        .catch(() => {
          dispatch({type: types.SHOW_ERROR_MODAL});
          reject();
        });
    });
  };
}

export function saveUser(userName, userInfo, permissionTable) {
  return function(dispatch) {
    dispatch({
      type: types.SAVE_USER_ATTEMPT
    });

    return dispatch(updateUser(userName, userInfo, permissionTable));
  };
}

export function toggleUserPermission(subscriptionId, permissionType) {
  return {
    type: types.TOGGLE_USER_PERMISSION,
    payload: {
      subscriptionId: subscriptionId,
      permissionType: permissionType
    }
  };
}

export function savePasswordChange(username, password)
{
  return function(dispatch) {
    let passwordData = {
      UserName: username,
      NewPassword: password,
      ConfirmPassword: password
    };

    axios.post(endpoints.CHANGE_USER_PASSWORD, passwordData)
      .then(() => {
        dispatch({
          type: types.USER_PASSWORD_CHANGED
        });
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });
  };
}




/** WEBPACK FOOTER **
 ** ./src/modules/users/actions.js
 **/